import React, { useState, useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import OGCChiefComplaintTest from '../components/Toolbox/OGCChiefComplaintTest';

const Toolbox = () => {
  const [selectedTool, setSelectedTool] = useState(null);
  const { clid } = useAuth();

  const allTools = [
    {
      id: 'ogc-chief-complaint-test',
      title: 'OGC Chief Complaint Test',
      description: 'Test to convert the chief complaint to the service name',
      component: OGCChiefComplaintTest,
      requireClid: ['HKSH0004', 'HKSH0005'],
    },
  ];

  // Filter tools based on clid permission
  const tools = useMemo(() => {
    return allTools.filter(tool => {
      // If tool doesn't have requireClid, it's accessible to all
      if (!tool.requireClid || tool.requireClid.length === 0) {
        return true;
      }
      // Check if user's clid is in the requireClid array
      return tool.requireClid.includes(clid);
    });
  }, [clid]);

  const handleToolSelect = (tool) => {
    // Double-check permission before selecting tool
    if (tool.requireClid && tool.requireClid.length > 0) {
      if (!tool.requireClid.includes(clid)) {
        console.warn(`Access denied: Tool ${tool.id} requires clid ${tool.requireClid.join(', ')}`);
        return;
      }
    }
    setSelectedTool(tool);
  };

  const handleBack = () => {
    setSelectedTool(null);
  };

  // Show landing page with tool cards
  if (!selectedTool) {
    return (
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Tool Box</h1>
          <p className="text-gray-600">Select a tool to get started</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {tools.map((tool) => (
            <div
              key={tool.id}
              onClick={() => handleToolSelect(tool)}
              className="bg-white rounded-lg shadow p-6 cursor-pointer hover:shadow-lg transition-shadow duration-200"
            >
              <h2 className="text-xl font-bold text-gray-900 mb-3">{tool.title}</h2>
              <p className="text-gray-600 text-sm">{tool.description}</p>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Show agent interface for selected tool
  const ToolComponent = selectedTool.component;
  return <ToolComponent tool={selectedTool} onBack={handleBack} />;
};

export default Toolbox;

